import React, { useState } from 'react';
import './App.css';
import ElectorateSearch from './components/ElectorateSearch';
import ElectionPrediction from './components/ElectionPrediction';
import ElectorateList from './components/ElectorateList';

function App() {
  const [selectedElectorate, setSelectedElectorate] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query) {
      setSelectedElectorate('');
    }
  };

  const handleElectorateSelect = (electorate) => {
    setSelectedElectorate(electorate);
    setSearchQuery('');
  };

  return (
    <div className="App">
      <div className="App-header">
        <h1>Australian Federal Election 2025</h1>
        <p className="ai-disclaimer">AI-Generated Predictions</p>
        <p className="prediction-disclaimer">
          These predictions are generated by our AI model and will be updated as the campaign progresses. 
          They are based on current data and trends, but <b>should not be considered definitive.</b> 
          There might be some <b>inaccuracies and inconsistencies</b> in the predictions.
          We are working on improving the data and predictions and this will be <b>continuously updated</b> until election day.
          The current limitations of AI models apply and the predictions <b>are not 100% accurate. </b>
          For more information or any other questions, please contact us at admin@aiptf.com.
        </p>
        <ElectionPrediction />
        <ElectorateSearch 
          onSearch={handleSearch}
          onElectorateSelect={handleElectorateSelect}
          currentSelectedElectorate={selectedElectorate}
        />
        <ElectorateList 
          onElectorateSelect={handleElectorateSelect}
          selectedElectorate={selectedElectorate}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
}

export default App;
